import React, { useState, useEffect, useMemo,useCallback } from "react";
import { ToastContainer } from "react-toastify";
import Select from "react-select";
import { Button, Modal, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import validator from "validator"; //https://www.npmjs.com/package/validator
import { useSelector, useDispatch } from "react-redux";
import swal from "sweetalert";

import useFullPageLoader from "../../../hooks/useFullPageLoader";

import PageTitle from "../../layouts/PageTitle";
import Table from "../../components/table/ReactTable/Table";
import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import { userActions, masterActions } from "../../../_store";
import Toastr from "../../components/common/Toastr";
import generatePDF from "../../components/export/generatePDF";
import generateXlsx from "../../components/export/generateXlsx";

const UserList = () => {
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const currentUser = useSelector((x) => x.auth.user);
  const userList = useSelector((x) => x.users.users);
  const user = useSelector((x) => x.users.user);
  const userResponse = useSelector((x) => x.users.userResponse);
  const userTypeDrpList = useSelector((x) => x.master.userTypeDrpList);
  const warehouseDrpList = useSelector((x) => x.master.warehouseDrpList);
  const deleteUserResponse = useSelector((x) => x.users.deleteUserResponse);
  const resetResponse = useSelector((x) => x.users.resetPassword);
  const isLoading = useSelector((x) => x.users.isLoading);

  //Add State
  const [addFormData, setAddFormData] = useState({
    UserID: 0,
    WarehouseID: 0,
    FirstName: "",
    LastName: "",
    EmailID: "",
    PhoneNumber: "",
    UserTypeID: 0,
    Status: 1,
    CreatedBy: currentUser.Id,
    WarehouseOption: null,
    UserTypeOption: null,
    IsEmailIDValid: true,
    IsPhoneValid: true,
    Extension: "",
  });

  const newFormData = { ...addFormData };

  let styles = {
    control: (styles) => ({ ...styles, border: "1px solid red" }),
  };

  const COLUMNS = [
    {
      Header: "First Name",
      Footer: "First Name",
      accessor: "FirstName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Last Name",
      Footer: "Last Name",
      accessor: "LastName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Email Id",
      Footer: "Email Id",
      accessor: "EmailID",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Phone",
      Footer: "Phone",
      accessor: "PhoneNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "User Type",
      Footer: "User Type",
      accessor: "UserType",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Status",
      Footer: "Status",
      accessor: "StatusName",
      Cell: ({ value }) => {
        return (
          <>
            <Badge variant="primary light badge-lg"> {value}</Badge>
          </>
        );
      },
      Filter: ColumnFilter,
    },
    {
      Header: "",
      Footer: "",
      accessor: "UserID",
      disableFilters: true,
      Cell: ({ value , row}) => {
        return (
          <>
            <div className="d-flex">
              <Link
                onClick={() => handleEditClick(value)}
                className="btn btn-primary shadow btn-xs sharp me-1"
                title="Edit"
              >
                <i className="fas fa-pen"></i>
              </Link>
               {currentUser.UserTypeID  !== 8 &&
              <Link
                onClick={() => handleDeleteClick(value)}
                className="btn btn-danger shadow btn-xs sharp me-1"
                title="Delete"
              >
                <i className="fa fa-trash"></i>
              </Link>
               }
              {currentUser.UserTypeID  === 1 &&
              <Link
                onClick={() => handleresetPasswordClick(value, row)}
                className="btn btn-warning shadow btn-xs sharp"
                title="Password Reset"
              >
                <i className="fas fa-user-lock"></i>
              </Link>
                }

            </div>
          </>
        );
      },
    },
  ];

  const columns = useMemo(() => COLUMNS, []);

  const generateColumns = [
    {
      header: "First Name",
      dataKey: "FirstName",
    },
    {
      header: "Last Name",
      dataKey: "LastName",
    },
    {
      header: "Email Id",
      dataKey: "EmailID",
    },
    {
      header: "Phone",
      dataKey: "PhoneNumber",
    },
    {
      header: "User Type",
      dataKey: "UserType",
    },
    {
      header: "Status",
      dataKey: "StatusName",
    },
  ];

  useEffect(() => {
    showLoader();
    dispatch(masterActions.GetUserTypeList());
    let WareHouseID = 0;
    let Status = 1;
    dispatch(masterActions.GetWarehouseList({ WareHouseID, Status }));
    dispatch(userActions.getUserAll({ CurrentUserID: currentUser.Id }));
  }, [dispatch]);

  const [isOpenModal, setOpenModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
    const [finalTableData, setFinalTableData] = useState([]);
      const handleTableDataUpdate = useCallback((data) => {
        setFinalTableData(data);
      }, []);

  // handle Change function
  const handleChange = (event) => {
    event.preventDefault();

    const regexString = /^[a-zA-Z\s]*$/;
    const regexNumber = /^[0-9\b\s()-]+$/;
    const regexExtensionNumber = /^[0-9\b\s]+$/;
    const yop = /[^A-Za-z 0-9]/g;
    const IsRegexNumber = /^\((\d{3})\)[ ](\d{3})[-](\d{4})$/;
    const fieldName = event.target.getAttribute("name");

    const fieldValue = event.target.value;
    if (fieldValue && fieldValue.trim()) {
      if (fieldName === "FirstName" || fieldName === "LastName") {
        if (fieldValue === "" || regexString.test(fieldValue)) {
          newFormData[fieldName] = fieldValue;
        }
      } else if (fieldName === "PhoneNumber" && fieldValue) {
        if (fieldValue === "" || regexNumber.test(fieldValue)) {
          newFormData[fieldName] = fieldValue;
        }
      } else if (fieldName === "Extension" && fieldValue) {
        if (fieldValue === "" || regexExtensionNumber.test(fieldValue)) {
          newFormData[fieldName] = fieldValue.replace(/\s/g, "");
        }
      } else {
        newFormData[fieldName] = fieldValue;
      }
    } else {
      newFormData[fieldName] = fieldValue.trim();
    }

    if (fieldName === "EmailID" && fieldValue) {
      newFormData.IsEmailIDValid = validator.isEmail(fieldValue);
    } else if (fieldName === "PhoneNumber" && fieldValue) {

      newFormData.IsPhoneValid = !!IsRegexNumber.test(fieldValue);
    }
    setAddFormData(newFormData);
  };

  // handle Dropdown Change function
  const handleDrpChange = (event, title) => {
    newFormData[title] = event.value && parseInt(event.value);
    if (title === "WarehouseID") {
      newFormData.WarehouseOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "UserTypeID") {
      newFormData.UserTypeOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    }
    setAddFormData(newFormData);
  };

  // handle Check Box Click function
  const handleCkBoxChange = (event, title) => {
    newFormData[title] = event.target.checked === true ? 1 : 2;
    setAddFormData(newFormData);
  };

  const handlePoupClick = () => {
    newFormData.WarehouseID = newFormData.UserTypeID = newFormData.UserID = 0;

    newFormData.FirstName =
      newFormData.LastName =
      newFormData.EmailID =
      newFormData.PhoneNumber =
      newFormData.Extension =
      "";
    newFormData.WarehouseOption = null;
    newFormData.UserTypeOption = null;
    newFormData.IsEmailIDValid = true;
    newFormData.IsPhoneValid = true;
    newFormData.Status = 1;
    setAddFormData(newFormData);
    setOpenModal(true);
    setSubmitted(false);
    //Toastr('Action successfully executed!', 'success');
  };

  const handleEditClick = (Id) => {
    showLoader();
    dispatch(
      userActions.getUserById({ UserID: Id, CurrentUserID: currentUser.Id })
    );
    setOpenModal(true);
    setSubmitted(false);
  };

  // Edit User handleEditClick
  useEffect(() => {
    if (user && user.UserID > 0) {
      newFormData.UserID = user.UserID;
      newFormData.WarehouseID = user.WarehouseID;
      newFormData.FirstName = user.FirstName;
      newFormData.LastName = user.LastName;
      newFormData.EmailID = user.EmailID;
      newFormData.PhoneNumber = user.PhoneNumber;
      newFormData.UserTypeID = user.UserTypeID;
      newFormData.Status = user.Status;
      newFormData.Extension = user.Extension;
      newFormData.WarehouseOption = {
        value: user.WarehouseID,
        label: user.WareHouseNumber,
      };
      newFormData.UserTypeOption = {
        value: user.UserTypeID,
        label: user.UserType,
      };
      newFormData.IsEmailIDValid = true;
      newFormData.IsPhoneValid = true;
      setAddFormData(newFormData);
      hideLoader();
    }
  }, [user]);
  const handleresetPasswordClick = (Id, row) => {
    swal({
      title: "Are you sure you want to reset this password?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((reset) => {
      if (reset) {
        showLoader();
        if (user) {
          dispatch(
            userActions.getUserMailId({
              UserID: Id,
              CurrentUserID: currentUser.Id,
              EmailID: row.original.EmailID,
              FirstName: row.original.FirstName,
              LastName: row.original.LastName
            })
          );
        }
      }
    });
  };
  
  const handleDeleteClick = (Id) => {
    swal({
      title: "Are you sure, you want to delete this User?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoader();
        dispatch(
          userActions.deleteUser({ UserID: Id, DeletedBy: currentUser.Id })
        );
      }
    });
  };

  // handleDeleteClick
  useEffect(() => {
    if (deleteUserResponse === 1) {
      hideLoader();
      Toastr("User deleted successfully", "success");
      dispatch(userActions.getUserAll({ CurrentUserID: currentUser.Id }));
    } else if (deleteUserResponse === -1) {
      hideLoader();
      Toastr("Error ", "warning");
    }
  }, [deleteUserResponse]);

    // handleDeleteClick
    useEffect(() => {
      if (resetResponse === 2) {
        hideLoader();
        Toastr("Password Resetted successfully", "success");
      } else if (resetResponse === -1) {
        hideLoader();
        Toastr("Error ", "warning");
      }
    }, [resetResponse]);

  // Submit data function
  const handleSubmit = (event) => {

    event.preventDefault();

    showLoader();

    var error = false;
    if (
      !addFormData.WarehouseID ||
      addFormData.WarehouseID === 0 ||
      !addFormData.FirstName ||
      !addFormData.LastName ||
      !addFormData.EmailID ||
      !addFormData.PhoneNumber ||
      !addFormData.UserTypeID ||
      addFormData.UserTypeID === 0 ||
      addFormData.IsPhoneValid === false ||
      addFormData.IsEmailIDValid === false
    ) {
      error = true;
    }

    let alertMsg;

    if (addFormData.IsEmailIDValid === false) {
      alertMsg = "Please fill in the Email Id in valid form";
    }
    if (!addFormData.EmailID) {
      alertMsg = "Please fill in the Email Id";
    }
    if (addFormData.IsPhoneValid === false) {
      alertMsg = "Please fill in the Phone number in valid form";
    }
    if (!addFormData.PhoneNumber) {
      alertMsg = "Please fill in the Phone number";
    }
    if (addFormData.PhoneNumber.length < 14) {
      alertMsg = "Please fill in the Phone number in valid format";
    }
    if (!addFormData.EmailID && !addFormData.PhoneNumber) {
      alertMsg = "Please fill in the Phone number & Email Id ";
    }
    if (
      addFormData.IsPhoneValid === false &&
      addFormData.IsEmailIDValid === false
    ) {
      alertMsg = "Please fill in the Phone number & Email Id in valid form";
    }
    if (
      !addFormData.WarehouseID ||
      addFormData.WarehouseID === 0 ||
      !addFormData.FirstName || !addFormData.LastName ||
      !addFormData.UserTypeID ||
      addFormData.UserTypeID === 0 ||
      !addFormData.PhoneNumber
    ) {
      alertMsg = "Please fill in the required missing fields";
    }
    //#endregion
    if (!error) {
      dispatch(userActions.saveUser(newFormData));
    } else {
      hideLoader();
      setSubmitted(true);
      // alertMsg="Missing";
      alertMsg && Toastr(`${alertMsg}`, "warning");
    }
  };

  // User Add And Update
  useEffect(() => {
    if (userResponse === 1) {
      hideLoader();
      Toastr("User saved successfully", "success");
      dispatch(userActions.getUserAll({ CurrentUserID: currentUser.Id }));
      newFormData.WarehouseID = newFormData.UserTypeID = 0;
      newFormData.FirstName =
        newFormData.LastName =
        newFormData.EmailID =
        newFormData.PhoneNumber =
        "";
      setOpenModal(false);
      setAddFormData(newFormData);
    } else if (userResponse === 2) {
      hideLoader();
      Toastr("User updated successfully", "success");
      dispatch(userActions.getUserAll({ CurrentUserID: currentUser.Id }));
      newFormData.WarehouseID = newFormData.UserTypeID = 0;
      newFormData.FirstName =
        newFormData.LastName =
        newFormData.EmailID =
        newFormData.PhoneNumber =
        "";
      setOpenModal(false);
      setAddFormData(newFormData);
    } else if (userResponse === -1) {
      hideLoader();
      Toastr("Email id already exists ", "warning");
    }
  }, [userResponse]);

  ///  export  //
  const handleClickPDF = () => {
    let title = "User List";
    const columnStyles = {
      FirstName: { halign: "left", cellWidth: 40 },
      LastName: { halign: "left", cellWidth: 40 },
      EmailID: { halign: "left", cellWidth: 40 },
      PhoneNumber: { halign: "center", cellWidth: 40 },
      UserType: { halign: "left", cellWidth: 40 },
      StatusName: { halign: "center", cellWidth: 40 },
    };
    generatePDF(finalTableData, generateColumns, true, title, columnStyles);
  };

  const handleClickExcel = () => {
    let title = "User List";
    let generateExcelColumns = [
      "First Name",
      "Last Name",
      "Email Id",
      "Phone",
      "User Type",
      "Status",
    ];
    let new_categoryList =
      finalTableData &&
      finalTableData.map(function (obj) {
        return {
          FirstName: obj.FirstName,
          LastName: obj.LastName,
          EmailID: obj.EmailID,
          Phone: obj.PhoneNumber,
          UserType: obj.UserType,
          StatusName: obj.StatusName,
        };
      });

    generateXlsx(new_categoryList, generateExcelColumns, title);
  };

  const handleClosePopup = () => {
    dispatch(userActions.clearUserResponse());
    setOpenModal(false);
  };

  useEffect(() => {

    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);

  return (
    <>
      <PageTitle activeMenu="Manage User" motherMenu="Users" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">User List</h4>
          <div className="float-sm-end">
            {userList && userList.length > 0 && (
              <>
                <Button
                  className="me-2"
                  variant="danger btn-rounded"
                  onClick={handleClickPDF}
                >
                  <span className="btn-icon-start text-danger">
                    <i className="fa fa-solid fa-file-pdf"></i>
                    {/* <i className="fa fa-regular fa-file-excel"></i> */}
                  </span>
                  PDF
                </Button>
                <Button
                  className="me-2"
                  variant="secondary btn-rounded"
                  onClick={handleClickExcel}
                >
                  <span className="btn-icon-start text-secondary">
                    {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                    <i className="fa fa-regular fa-file-excel"></i>
                  </span>
                  Excel
                </Button>
              </>
            )}
            {currentUser.UserTypeID !==8 && (
            <Button
              className="me-2"
              variant="primary btn-rounded"
              onClick={handlePoupClick}
            >
              <span className="btn-icon-start text-primary">
                <i className="fa fa-plus color-info" />
              </span>
              Add
            </Button>
             )}
          </div>
        </div>
        <div className="card-body">
          <Table columns={columns} data={userList} onDataUpdate={handleTableDataUpdate} />
        </div>
      </div>
      {/* <!-- Modal --> */}
      <Modal className="fade bd-example-modal-lg" show={isOpenModal} size="lg">
        <Modal.Header>
          <Modal.Title>
            {newFormData.UserID > 0 ? "Edit User" : "Add User"}
          </Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => handleClosePopup()}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
            <div className="col-md-6 mb-4">
  <label className="text-black font-w500">
    Warehouse Number<span className="text-danger">*</span>
  </label>
  <Select
    classNamePrefix={"custom_select_css"}
    name="WarehouseID"
    value={newFormData.WarehouseOption}
    options={warehouseDrpList}
    onChange={(event) => handleDrpChange(event, "WarehouseID")}
    styles={submitted && newFormData.WarehouseID === 0 ? styles : ""}
    isDisabled={currentUser.UserTypeID === 8}  // ✅ disable only for UserTypeId = 8
  />
</div>

              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  First Name
                  <span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${submitted && !newFormData.FirstName && "border-danger"
                      }`}
                    autoComplete="off"
                    name="FirstName"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.FirstName}
                    placeholder="First Name"
                    maxLength={50}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">Last Name<span className="text-danger">*</span></label>
                <div className="contact-name">
                  <input
                    type="text"
                    // className={`form-control ${newFormData.LastName}`}
                    className={`form-control ${submitted && !newFormData.LastName && "border-danger"
                      }`}
                    autoComplete="off"
                    name="LastName"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.LastName}
                    placeholder="Last Name"
                    maxLength={50}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>

              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Email Id<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${newFormData.UserID > 0 ? "readonly_css" : ""
                      } ${submitted && !newFormData.EmailID && "border-danger"}`}
                    autoComplete="off"
                    name="EmailID"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.EmailID}
                    placeholder="Email Id"
                    maxLength={50}
                    readOnly={newFormData.UserID > 0 ? true : false}
                  />
                  <span className="validation-text text-danger">
                    {!newFormData.IsEmailIDValid &&
                      "Please enter valid Email Id"}
                  </span>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">
                  Phone Number<span className="text-danger">*</span>
                </label>
                <div className="input-group mb-2">
                  <div className="input-group-text">+1</div>

                  <input
                    type="text"
                    className={`form-control ${submitted &&
                      (!newFormData.PhoneNumber ||
                        newFormData.PhoneNumber.length < 14) &&
                      "border-danger"
                      }`}
                    autoComplete="off"
                    name="PhoneNumber"
                    required="required"
                    value={newFormData.PhoneNumber}
                    onChange={handleChange}
                    maxLength={14}
                    placeholder="(XXX) XXX-XXXX"
                  />
                  <span className="validation-text text-danger">
                    {!newFormData.IsPhoneValid &&
                      "Please enter valid Phone Number eg.(XXX) XXX-XXXX"}
                  </span>
                </div>
              </div>
              {/* <div className="col-md-6 mb-4">
                                <label className="text-black font-w500">
                                    Phone Number<span className="text-danger">*</span>
                                </label>
                                <div className="input-group">
                                    <div className="input-group-text">1</div>
                                    <div className="contact-name">
                                        <input type="text"
                                            className={`form-control ${(submitted && (!newFormData.PhoneNumber || newFormData.PhoneNumber.length < 14)) && 'border-danger'}`}
                                            autoComplete="off"
                                            name="PhoneNumber" required="required"
                                            value={newFormData.PhoneNumber}
                                            onChange={handleChange}
                                            maxLength={14}
                                            placeholder="(XXX) XXX-XXXX"


                                        />

                                    </div>
                                </div>
                            </div> */}

              <div className="col-md-6 mb-4">
                <div className="contact-name">
                  <label className="text-black font-w500">
                    User Type<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="UserTypeID"
                    value={newFormData.UserTypeOption}
                    onChange={(event) => handleDrpChange(event, "UserTypeID")}
                    options={userTypeDrpList}
                    styles={
                      submitted && newFormData.UserTypeID === 0 ? styles : ""
                    }
                    isDisabled={(newFormData.UserID > 0 && (currentUser.UserTypeID !==1 && currentUser.UserTypeID !==2)) ? true : false}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="text-black font-w500">Extension</label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${newFormData.Extension}`}
                    autoComplete="off"
                    name="Extension"
                    required="required"
                    value={newFormData.Extension}
                    onChange={handleChange}
                    maxLength={6}
                    placeholder="Extension"
                  />
                </div>
              </div>

              <div className="col-md-6 mb-5">
  <label className="text-black font-w500">Active</label>
  <div>
    <div className="form-check form-switch">
      <input
        className="form-check-input"
        type="checkbox"
        role="switch"
        id="flexSwitchCheckDefault"
        name="Status"
        checked={newFormData.Status === 1 ? true : false}
        onChange={(event) => handleCkBoxChange(event, "Status")}
        disabled={currentUser.UserTypeID === 8}   // ✅ disable toggle for UserTypeId=8
      />
    </div>
  </div>
</div>

            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="danger light"
            // onClick={() => setOpenModal(false)}
            onClick={() => handleClosePopup()}
          >
            Close
          </Button>
          <Button
            variant=""
            // onClick={() => setLargeModal(false)}
            onClick={handleSubmit}
            className="btn btn-primary"
          >
            {newFormData.UserID > 0 ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>

      {loader}
    </>
  );
};

export default UserList;
